import React, { useState } from 'react';

import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button
} from '@mui/material';

import {WorkQueueFoldersInfoContent} from "./WorkQueueFoldersInfoContent";

export default function WorkQueueFoldersInfoDialogue({open, onClose, selectorContractGridAPI
                                        }) {

    const handleCloseInfo = () => {
        onClose(true);
    };

    const info = WorkQueueFoldersInfoContent(selectorContractGridAPI);

    return (
        <>

            <Dialog
                open={open}
                onClose={onClose}
            >

                <DialogTitle>
                    {info.title}
                </DialogTitle>

                <DialogContent>
                    {info.content}
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleCloseInfo}>
                        Close
                    </Button>
                </DialogActions>

            </Dialog>

        </>
    );
}